import { getBookItAgainTripList } from "../../../Actions/LogicActions/BookItAgain/GetBookItAgainTripList";
import { uiPreferencesAction } from "../../../Actions/LogicActions/Search/GetUIPreferencesAction";
import { searchBookingAction } from "../../../Actions/LogicActions/SearchBooking/SearchBookingAction";
import { addOfferToBookingAction } from "../../../Actions/UIActions/BookItAgain/AddOfferToBookingAction";
import { bookItAgainContinueButtonAction } from "../../../Actions/UIActions/BookItAgain/BookItAgainContinueButtonAction";
import { bookItAgainDateClickAction } from "../../../Actions/UIActions/BookItAgain/BookItAgainDateClickAction";
import { bookItAgainModifiedDateAction } from "../../../Actions/UIActions/BookItAgain/BookItAgainModifiedDateAction";
import { bookItAgainShowModalAction } from "../../../Actions/UIActions/BookItAgain/BookItAgainShowModalAction";
import { bookItAgainUpcomingPastClickAction } from "../../../Actions/UIActions/BookItAgain/BookItAgainUpcomingPastClickAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { getTranslatedMessage } from "../../../Lib/Utils/i18n";
import { isActionRunSuccessfully } from "../../../Lib/Utils/validationUtil";
import { bookingTree, evtTree } from "../../../Orchestrator/ConstantTree";
import { bookItAgainTree } from "../../../Orchestrator/ConstantTree/BookItAgain/BookItAgainTree";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TripTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IBookedTrips } from "../../../Orchestrator/Types/Index";
import { ICalendarStateParams, IGetBookItAgainTripListParams, ISelectDateClickActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/BookItAgainActionParams";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { ISearchBookingParams } from "../../../Orchestrator/Types/Interface/ActionParams/SearchBookingParams";
import { showNotification } from "../../../Services/notificationService";
import { BookItAgainContext } from "../Context/BookItAgainContext";
import { isWidgetEnabled } from "../../../Lib/Utils/isWidgetEnabled";

class BookItAgainInitStep extends StepFlow {
    get stepName() { return "BookItAgainInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on({
                eventName: bookItAgainTree.BookItAgainInit,
                handler: async () => {
                    if (this.hasSignaledNext) return;
                    if (!isWidgetEnabled("bookItAgain")) return;
                    await getBookItAgainTripList.execute();
                }
            })
        )
        /**
        * I register this step here because I want to start hyper fast book it again flow from home page
        * and I link book it again flow into home page flow as a step.
        * This steps just allow date selection and display trip details by updating recoil state
        */
        this.registerEventSubscription(
            _eventBus.on<IBookedTrips, void>({
                eventName: bookItAgainTree.Modal.Show,
                handler: async ({ data }) => {
                    if (data) {
                        const context = this.getCtx<BookItAgainContext>("bookItAgainContext")!
                        await bookItAgainShowModalAction.setParams({ trip: data })
                        await bookItAgainShowModalAction.execute()
                    }
                }
            })
        )

        // this.registerEventSubscription(
        //     _eventBus.on<IGetBestPriceActionParams, void>({
        //         eventName: bookItAgainTree.Calender.BestPrice,
        //         handler: async ({ data }) => {
        //             if (data) {
        //                 await getBestPriceAction.setParams({
        //                     selectedTrip: data.selectedTrip,
        //                     calendarDayInterval: data.calendarDayInterval,
        //                     type: data?.type,
        //                     selectedRange: data.selectedRange
        //                 })
        //                 await getBestPriceAction.execute()
        //                 if (isActionRunSuccessfully(getBestPriceAction)) {
        //                     const result = getBestPriceAction.result!
        //                     const context = this.getCtx<BookItAgainContext>("bookItAgainContext")!
        //                     if (context) {
        //                         context.actionResult = result
        //                         context.bestPrices = result?.data || []
        //                     }
        //                 }
        //             }
        //         }
        //     })
        // )

        this.registerEventSubscription(
            _eventBus.on({
                eventName: bookItAgainTree.GetInterval.Get,
                handler: async () => {
                    await uiPreferencesAction.execute()
                    if (isActionRunSuccessfully(uiPreferencesAction)) {
                        const result = uiPreferencesAction.result!;
                        const context = this.getCtx<BookItAgainContext>("bookItAgainContext")!
                        if (context) {
                            context.calendarDayInterval = result?.calendarDayInterval || 180; // Default to 180 days if not set
                        }
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<ICalendarStateParams, void>({
                eventName: bookItAgainTree.Date.Change,
                handler: async ({ data }) => {
                    if (data) {
                        const context = this.getCtx<BookItAgainContext>("bookItAgainContext")!
                        await bookItAgainModifiedDateAction.setParams(data)
                        await bookItAgainModifiedDateAction.execute()
                        if (isActionRunSuccessfully(bookItAgainModifiedDateAction)) {
                            const result: IDefaultActionResult = bookItAgainModifiedDateAction.result!
                            if (context) {
                                context.actionResult = result
                            }
                        }
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<ISelectDateClickActionParams, void>({
                eventName: bookItAgainTree.Date.Click,
                handler: async ({ data }) => {
                    if (data) {
                        const context = this.getCtx<BookItAgainContext>("bookItAgainContext")!
                        if (context) {

                            await bookItAgainDateClickAction.setParams(data);
                            await bookItAgainDateClickAction.execute();


                            if (bookItAgainDateClickAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                                const actionResult: IDefaultActionResult = bookItAgainDateClickAction.result!;
                                if (context) {
                                    context.actionResult = actionResult
                                }
                                if (actionResult.status === "success") {
                                    if (data.direction === TripTypeEnum.OUT_BOUND && data.tripType === "oneWayTrip") {
                                        context.continueToCheckout = true
                                    } else {
                                        if (data.direction === TripTypeEnum.IN_BOUND && data.selectedRange && data.selectedRange[1]) {
                                            context.continueToCheckout = true
                                            context.uniqueOffers = actionResult?.data?.uniqueOffers || []
                                        } else if (data.direction === TripTypeEnum.OUT_BOUND) {

                                        }
                                    }
                                } else {
                                    context.continueToCheckout = false
                                }
                            }
                        }
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: bookItAgainTree.Continue.Click,
                handler: async ({ data }) => {
                    const context = this.getCtx<BookItAgainContext>("bookItAgainContext")!
                    if (context && context.continueToCheckout) {
                        const actionPayload: IDefaultActionResult = {
                            data: {
                                ...context?.actionResult?.data || {},
                                needToHide: true
                            },
                            message: context.actionResult.message || "",
                            status: context.actionResult.status || "fail"
                        }
                        await bookItAgainContinueButtonAction.setParams(actionPayload);
                        await bookItAgainContinueButtonAction.execute();

                        if (bookItAgainContinueButtonAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                            const data: IDefaultActionResult = bookItAgainContinueButtonAction.result!;
                            if (context) {
                                context.actionResult = data
                            }
                            if (data.status === "success") {
                                /**
                                 * This is because, from here checkout flow will start but if pathname is /checkout then orchestrator also start checkout flow 
                                 * Now I have two time Checkout flow is running so to avoid it I set checkoutFromWithLogin true
                                 * This flag will be used in orchestrator if it is true then it will not start checkout flow again
                                */
                                try {
                                    sessionStorage.setItem("checkoutFromWithLogin", "true");
                                } catch (error) {
                                    console.error("Error setting sessionStorage checkoutFromWithLogin:", error);
                                }

                                const biaContext = this.getCtx<BookItAgainContext>("bookItAgainContext");
                                if (biaContext) {
                                    biaContext.routeTo = ["CheckoutFlow"];
                                    this.next();
                                }


                                // Delay the ROUTE_CHANGE event emission slightly
                                setTimeout(() => {
                                    _eventBus.emit({
                                        eventName: "ROUTE_CHANGE",
                                        data: "/checkout"
                                    });
                                }, 0); // setTimeout with 0ms delay
                            } else {
                                showNotification('warning', getTranslatedMessage("noOffers"), getTranslatedMessage("selectDifferentSearch"));
                            }
                        }
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: bookItAgainTree.Round.InBound.Continue.Click,
                handler: async ({ data }) => {
                    const context = this.getCtx<BookItAgainContext>("bookItAgainContext")!
                    if (context && context.continueToCheckout) {
                        const actionPayload: IDefaultActionResult = {
                            data: {
                                ...context.actionResult.data,
                                bookingId: context?.roundOutboundPrebookData?.id || ""
                            },
                            message: context.actionResult.message || "",
                            status: context.actionResult.status || "fail"
                        }
                        addOfferToBookingAction.setParams(actionPayload)
                        await addOfferToBookingAction.execute();

                        if (addOfferToBookingAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                            const data: IDefaultActionResult = addOfferToBookingAction.result!;
                            if (data.status === "success") {
                                /**
                                 * This is because, from here checkout flow will start but if pathname is /checkout then orchestrator also start checkout flow 
                                 * Now I have two time Checkout flow is running so to avoid it I set checkoutFromWithLogin true
                                 * This flag will be used in orchestrator if it is true then it will not start checkout flow again
                                */
                                try {
                                    sessionStorage.setItem("checkoutFromWithLogin", "true");
                                } catch (error) {
                                    console.error("Error setting sessionStorage checkoutFromWithLogin:", error);
                                }

                                const biaContext = this.getCtx<BookItAgainContext>("bookItAgainContext");
                                if (biaContext) {
                                    biaContext.routeTo = ["CheckoutFlow"];
                                    this.next();
                                }


                                // Delay the ROUTE_CHANGE event emission slightly
                                setTimeout(() => {
                                    _eventBus.emit({
                                        eventName: "ROUTE_CHANGE",
                                        data: "/checkout"
                                    });
                                }, 0); // setTimeout with 0ms delay
                            } else {
                                showNotification('warning', getTranslatedMessage("noOffers"), getTranslatedMessage("selectDifferentSearch"));
                            }
                        }
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: bookItAgainTree.Round.OutBound.Continue.Click,
                handler: async ({ data }) => {
                    const context = this.getCtx<BookItAgainContext>("bookItAgainContext")!
                    if (context) {
                        if (context.roundOutboundDateSelected === data) {
                            updateRecoilState("isRoundTripModalVisibleAtom", false);
                            updateRecoilState("isRoundTripInboundModalVisibleAtom", true);
                            return;
                        }
                    }
                    const actionPayload: IDefaultActionResult = {
                        data: {
                            ...context.actionResult.data,
                            needToHide: false
                        },
                        message: context.actionResult.message || "",
                        status: context.actionResult.status || "fail"
                    }
                    await bookItAgainContinueButtonAction.setParams(actionPayload);
                    await bookItAgainContinueButtonAction.execute();

                    if (bookItAgainContinueButtonAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                        const result: IDefaultActionResult = bookItAgainContinueButtonAction.result!;
                        if (result.status === "success") {
                            /**
                             * This is because, from here checkout flow will start but if pathname is /checkout then orchestrator also start checkout flow 
                             * Now I have two time Checkout flow is running so to avoid it I set checkoutFromWithLogin true
                             * This flag will be used in orchestrator if it is true then it will not start checkout flow again
                            */
                            try {
                                sessionStorage.setItem("checkoutFromWithLogin", "true");
                            } catch (error) {
                                console.error("Error setting sessionStorage checkoutFromWithLogin:", error);
                            }
                            const booking = result.data
                            context.roundOutboundPrebookData = booking

                            updateRecoilState("isRoundTripModalVisibleAtom", false);
                            updateRecoilState("isRoundTripInboundModalVisibleAtom", true);

                            context.roundOutboundDateSelected = data || ""
                        }
                    }
                }
            })
        )

        /**
         * This event need's to register here.
         * This is also register into SearchInitStep.
         * Reason to register here is, when user click on search we need to close BookItAgainFlow
         * So from here it will close BookItAgainFlow
        */
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: evtTree.SearchBar.SearchButton.Click,
                handler: async ({ data }) => {
                    const context = this.getCtx<BookItAgainContext>("bookItAgainContext")
                    if (context) {
                        context.routeTo = []
                        this.next()
                    }
                }
            })
        )

        this.registerEventSubscription(
            _eventBus.on<string, void>({
                eventName: bookItAgainTree.BookItAgainUpcomingPastClick,
                handler: async ({ data }) => {
                    bookItAgainUpcomingPastClickAction.setParams(data!)
                    await bookItAgainUpcomingPastClickAction.execute()
                }
            })
        )

        /**
        * This event used to close flow
        */
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: bookingTree.BookItAgain.Flow.Close,
                handler: async (payload) => {
                    const context = this.getCtx<BookItAgainContext>("bookItAgainContext")!
                    if (context) {
                        context.routeTo = []
                        this.next()
                    }
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        console.log("BookItAgain Init Step Execute.............................")
    }
}

export const BookItAgainInitStepDeclaration = new StepDefinition({
    stepName: "BookItAgainInit_Step",
    stepClass: BookItAgainInitStep
});